const commandKeys = require("./command-keys");
class ASTBuilder {
    ast;

    constructor(parser) {
        this.parser = parser;
        this.ast = {};
    }

    _initTree() {
        this.ast = {
            type: 'Program',
            params: []
        };
    }

    build(tokens) {
        this._initTree();
        this._parseTokens(tokens);
        return this.ast;
    }

    _isStartExpression(token) {
        return token.type === 'parenthesis' && token.value === '(';
    }

    _isEndOfExpression(token) {
        return token.type === 'parenthesis' && token.value === ')';
    }

    _isKeyword(token) {
        return commandKeys.map(commandKey => commandKey.toUpperCase()).includes(token.value?.toUpperCase());
    }

    _parseTokens(tokens) {
        let tokenIndex = 0;
        let node = null;
        while (tokenIndex < tokens.length) {
            [tokenIndex, node] = this.parseToken(tokens, tokenIndex);
            this.ast.params.push(node);
        }
    }

    parseToken(tokens, tokenIndex) {
        let token = tokens[tokenIndex];
        if (this._isStartExpression(token)) {
            return this.parseStatement(tokens, tokenIndex);
        }
        const tokenizer = this.parser.getTokenizer(token.type);
        if (tokenizer) {
            return tokenizer.parse(tokens, tokenIndex);
        }
        throw new TypeError(token.type);
    }


    parseStatement(tokens, current) {
        let token = tokens[++current];
        const node = {
            type: "expression",
            name: "",
            params: [],
        };

        if (this._isKeyword(token)) {
            node.name = token.value;
            token = tokens[++current];
        }

        while (!this._isEndOfExpression(token)) {
            const [newCurrent, param] = this.parseToken(tokens, current);
            current = newCurrent;
            node.params.push(param);
            token = tokens[current];
        }
        current++;
        return [current, node];
    }
}

module.exports = ASTBuilder;